import ApiClient from '@afosto/api/ApiClient';

class Coupons {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create categories
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new category
   * @returns {Promise}
   */
  createCouponCategory(body, options = {}) {
    return this.apiClient.request({
      url: `/odr/coupons/categories`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Create coupons
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new coupon
   * @returns {Promise}
   */
  createCoupons(body, options = {}) {
    return this.apiClient.request({
      url: `/odr/coupons/codes`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Disable coupon
   *
   * @param {string} code
   * @param {Object} options - The additional request options
   * @description Disable a coupon: it is marked as expired
   * @returns {Promise}
   */
  disableCoupon(code, options = {}) {
    return this.apiClient.request({
      url: `/odr/coupons/codes/${code}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get categories
   *
   * @param {Object} options - The additional request options
   * @description Get a listing of available coupon categories
   * @returns {Promise}
   */
  getCouponCategories(options = {}) {
    return this.apiClient.request({
      url: `/odr/coupons/categories`,
      method: 'get',
      ...options,
    });
  }

  /**
   * View category
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get a coupon category by ID
   * @returns {Promise}
   */
  getCouponCategory(id, options = {}) {
    return this.apiClient.request({
      url: `/odr/coupons/categories/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get coupons
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.categoryId]
   * @param {Object} options - The additional request options
   * @description Get a listing of available coupons
   * @returns {Promise}
   */
  getCoupons(query = {}, options = {}) {
    const params = {
      category_id: query.categoryId,
    };

    return this.apiClient.request({
      url: `/odr/coupons/codes`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Update category
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update coupon category
   * @returns {Promise}
   */
  updateCouponCategory(id, body, options = {}) {
    return this.apiClient.request({
      url: `/odr/coupons/categories/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * View coupon
   *
   * @param {string} code
   * @param {Object} options - The additional request options
   * @description Get a single coupon by ID
   * @returns {Promise}
   */
  viewCoupon(code, options = {}) {
    return this.apiClient.request({
      url: `/odr/coupons/codes/${code}`,
      method: 'get',
      ...options,
    });
  }
}

export const coupons = new Coupons();

export default Coupons;
